import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByKey',
    standalone: false
})
export class SortByKeyPipe implements PipeTransform {

  transform(value: any[], sortType: string, sortKey: string, convertToNumber: boolean): unknown {
    const arr = value;
    if(sortType === 'asc') {
      return arr?.sort((a,b) => ((convertToNumber ? +a[sortKey] : a[sortKey]) > (convertToNumber ? +b[sortKey] : b[sortKey])) ? 1 : (((convertToNumber ? +b[sortKey] : b[sortKey]) >(convertToNumber ? +a[sortKey] : a[sortKey])) ? -1 : 0));
    } else if(sortType === 'desc') {
      console.log('sortByKey', arr?.sort((a,b) => ((convertToNumber ? +a[sortKey] : a[sortKey]) < (convertToNumber ? +b[sortKey] : b[sortKey])) ? 1 : (((convertToNumber ? +b[sortKey] : b[sortKey]) < (convertToNumber ? +a[sortKey] : a[sortKey])) ? -1 : 0)));

      return arr?.sort((a,b) => ((convertToNumber ? +a[sortKey] : a[sortKey]) <(convertToNumber ? +b[sortKey] : b[sortKey])) ? 1 : (((convertToNumber ? +b[sortKey] : b[sortKey]) < (convertToNumber ? +a[sortKey] : a[sortKey])) ? -1 : 0));
    } else {
      return arr;
    }

  }

}
